import React from 'react';
import { graphql } from 'gatsby';
import { AlternateLanguage, PageContextType } from '../types';
import { PageMetadata } from '../components/PageMetadata';
import { Slices } from '../components/Slices';
import withLayout from './withLayout';

export type PageDataType = {
    lang: string;
    uid: string;
    type: string;
    alternate_languages: AlternateLanguage[];
    first_publication_date: string;
    last_publication_date: string;
    data: {
        title: {
            html: string;
            text: string;
        };
        meta_title: {
            text: string;
        } | null;
        meta_description: {
            text: string;
        } | null;
        meta_canonical: {
            url: string;
        } | null;
        meta_image: {
            url: string;
        } | null;
        meta_twitter_image: {
            url: string;
        } | null;
        body: any;
        home_page: string | null;
        show_navigation_header: 'yes' | 'no';
        show_footer: 'yes' | 'no';
        theme: 'Dark' | 'Light';
    };
};

export type PageTemplateProps = {
    location: Location;
    pageContext: PageContextType;
    data: {
        prismicPage: PageDataType;
    };
};

class PageTemplate extends React.Component<PageTemplateProps> {
    render() {
        const page = this.props.data.prismicPage;

        return (
            <React.Fragment>
                <PageMetadata page={page} pageContext={this.props.pageContext} />
                <Slices
                    location={this.props.location}
                    pageContext={this.props.pageContext}
                    slices={page.data.body}
                />
            </React.Fragment>
        );
    }
}

export const pageQuery = graphql`
    query($id: String!) {
        prismicPage(id: { eq: $id }) {
            uid
            lang
            type
            first_publication_date
            last_publication_date
            alternate_languages {
                lang
                uid
                type
                id
            }
            data {
                title {
                    html
                    text
                }
                meta_title {
                    text
                }
                meta_description {
                    text
                }
                meta_canonical {
                    url
                }
                meta_image {
                    url
                }
                meta_twitter_image {
                    url
                }
                body {
                    ...PrismicBlogFragment
                    ...PrismicCallToActionFragment
                    ...PrismicFaqFragment
                    ...PrismicFeatureFragment
                    ...PrismicFeaturedArtistsFragment
                    ...PrismicHeroFragment
                    ...PrismicLogoListFragment
                    ...PrismicMasteringDemosFragment
                    ...PrismicPressListFragment
                    ...PrismicPricingFragment
                    ...PrismicQuotesFragment
                    ...PrismicLinkListFragment
                    ...PrismicQuotesVideoFragment
                    ...PrismicResetPasswordFragment
                    ...PrismicSignupFragment
                    ...PrismicTextBlockFragment
                    ...PrismicTextGridFragment
                    ...PrismicVideoPlayerFragment
                    ...PrismicVisualFragment
                }
                home_page
                show_navigation_header
                show_footer
                theme
            }
        }
    }
`;

const Page = withLayout(PageTemplate);

export default Page;
